"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const translate_1 = require("shared/helper/translate");
const PlanHeader = ({ planName, type }) => {
    const premiumHeader = {
        premium_editing_only: (react_1.default.createElement("span", null,
            react_1.default.createElement(translate_1.T, { source: "curie.curie-premium" }))),
        premium_editing_only_admin: (react_1.default.createElement("span", null,
            react_1.default.createElement(translate_1.T, { source: "curie.curie-premium" }))),
        premium_editing_only_no_trial: (react_1.default.createElement("span", null,
            react_1.default.createElement(translate_1.T, { source: "curie.curie-premium" }))),
        premium_including_translation: (react_1.default.createElement("span", null,
            react_1.default.createElement(translate_1.T, { source: "rubriq.rubriq-premium-with-translation" }))),
        premium_including_translation_no_trial: (react_1.default.createElement("span", null,
            react_1.default.createElement(translate_1.T, { source: "rubriq.rubriq-premium-with-translation" }))),
        premium_editing: (react_1.default.createElement("span", null,
            react_1.default.createElement(translate_1.T, { source: "curie.curie-premium" }))),
        premium: (react_1.default.createElement("span", null,
            react_1.default.createElement(translate_1.T, { source: "rubriq.rubriq-premium-with-translation" }))),
        default: (react_1.default.createElement("span", null,
            react_1.default.createElement(translate_1.T, { source: "curie.curie-premium" }))),
    };
    return (react_1.default.createElement("h2", { className: "fw-bold m-0" },
        type === 'free_trial' && (react_1.default.createElement("span", null,
            react_1.default.createElement(translate_1.T, { source: "curie.starter" }))),
        type === 'premium' && (premiumHeader[planName] || premiumHeader.default),
        type === 'preferred_group' && react_1.default.createElement(translate_1.T, { source: "curie.preferred-group" })));
};
exports.default = PlanHeader;
